import { useLanguage } from '../LanguageContext';

/** Eye — universal symbol for vision / foresight */
function IconVision() {
  return (
    <svg
      className="vm-card__svg"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="12"
        cy="12"
        r="3.25"
        stroke="currentColor"
        strokeWidth="1.75"
      />
      <circle cx="12" cy="12" r="1" fill="currentColor" />
    </svg>
  );
}

/** Compass needle — direction & mission */
function IconMission() {
  return (
    <svg
      className="vm-card__svg"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle
        cx="12"
        cy="12"
        r="9.25"
        stroke="currentColor"
        strokeWidth="1.75"
      />
      <line
        x1="12"
        y1="12"
        x2="12"
        y2="5.75"
        stroke="currentColor"
        strokeWidth="2.35"
        strokeLinecap="round"
      />
      <line
        x1="12"
        y1="12"
        x2="12"
        y2="18.25"
        stroke="currentColor"
        strokeWidth="1.85"
        strokeLinecap="round"
        opacity="0.38"
      />
      <circle cx="12" cy="12" r="1.5" fill="currentColor" />
    </svg>
  );
}

export default function AboutSection() {
  const { t } = useLanguage();

  return (
    <section
      className="section section--about"
      id="about"
      aria-labelledby="about-heading"
    >
      <div className="about-panel">
        <div className="section__head">
          <h2 id="about-heading">{t('about.title')}</h2>
          <p className="section__sub section__sub--accent">{t('about.sub')}</p>
        </div>
        <div className="about-panel__body">
          <p>{t('about.body1')}</p>
          <p>{t('about.body2')}</p>
        </div>

        <div className="vm-cards">
          <article
            className="vm-card vm-card--vision"
            aria-labelledby="vision-title"
          >
            <div className="vm-card__icon" aria-hidden="true">
              <IconVision />
            </div>
            <h3 id="vision-title" className="vm-card__title">
              {t('about.visionTitle')}
            </h3>
            <p className="vm-card__text">{t('about.visionText')}</p>
          </article>

          <article
            className="vm-card vm-card--mission"
            aria-labelledby="mission-title"
          >
            <div className="vm-card__icon vm-card__icon--mission" aria-hidden="true">
              <IconMission />
            </div>
            <h3 id="mission-title" className="vm-card__title">
              {t('about.missionTitle')}
            </h3>
            <p className="vm-card__text">{t('about.missionText')}</p>
          </article>
        </div>
      </div>
    </section>
  );
}
